export default __webpack_public_path__ + "static/media/star-icon.3a89e1be.svg";